"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isClonedItem = exports.isTargetItem = exports.isActiveItem = exports.getRenderStageItemClasses = void 0;
var types_1 = require("../types"),
  common_1 = require("./common"),
  math_1 = require("./math"),
  getRenderStageItemClasses = function getRenderStageItemClasses(e, t) {
    void 0 === e && (e = 0);
    var s = t.fadeoutAnimationIndex,
      i = (0, exports.isActiveItem)(e, t) ? types_1.Modifiers.ACTIVE : "",
      n = (0, exports.isClonedItem)(e, t) ? types_1.Modifiers.CLONED : "",
      t = (0, exports.isTargetItem)(e, t) ? types_1.Modifiers.TARGET : "",
      e = e === s ? types_1.Classnames.ANIMATED : "";
    return (0, common_1.concatClassnames)(types_1.Classnames.STAGE_ITEM, i, n, t, e);
  },
  isActiveItem = (exports.getRenderStageItemClasses = getRenderStageItemClasses, function (e, t) {
    void 0 === e && (e = 0);
    var s = t.activeIndex,
      i = t.itemsInSlide,
      n = t.itemsOffset,
      r = t.infinite,
      t = t.autoWidth,
      o = (0, math_1.getShiftIndex)(i, n);
    return t && r ? e - o === s + n : (t = s + o, r ? t <= e && e < t + i : s <= e && e < t);
  }),
  isTargetItem = (exports.isActiveItem = isActiveItem, function (e, t) {
    void 0 === e && (e = 0);
    var s = t.activeIndex,
      i = t.itemsInSlide,
      n = t.itemsOffset,
      r = t.infinite,
      t = t.autoWidth,
      i = (0, math_1.getShiftIndex)(i, n);
    return r ? t && r ? e - i === s + n : e === s + i : e === s;
  }),
  isClonedItem = (exports.isTargetItem = isTargetItem, function (e, t) {
    void 0 === e && (e = 0);
    var s = t.itemsInSlide,
      i = t.itemsOffset,
      n = t.itemsCount,
      r = t.infinite,
      t = t.autoWidth;
    return !!r && (t && r ? e < s || n - 1 + s < e : e < (t = (0, math_1.getShiftIndex)(s, i)) || n - 1 + t < e);
  });
exports.isClonedItem = isClonedItem;